import {Component} from '@angular/core';
import {AppComponent} from '../../app.component';
import { AppMainComponent } from 'src/app/app.main.component';
@Component({
    selector: 'app-topbar',
    template: `
    <div class="layout-topbar">
        <div class="layout-topbar-left" *ngIf="appMain.isMobile()">
            <a href="javascript:void(0)" class="logo">
                <img  [src]="'assets/layout/images/logo-'+ (app.colorScheme === 'light' ? 'dark' : 'light') + '.svg'">
            </a>
        </div>
        <div class="layout-topbar-right"></div>
    </div>
    `,
    styles: [`
      .logo {
          background: #ffffff;
          margin:0;
      }
  `]
})
export class AppTopbarComponent {

    constructor(public app: AppComponent, public appMain: AppMainComponent) {}

}
